let permissions = {
  Users: {
    Create: 'Users.Create',
    View: 'Users.View',
    Update: 'Users.Update',
    Delete: 'Users.Delete',
  },
  Roles: {
    Create: 'Roles.Create',
    View: 'Roles.View',
    Update: 'Roles.Update',
    Delete: 'Roles.Delete',
    
  },

  Dashboard: {
    Inspections: 'Dashboards.Inspections',
    Inspections_Inspection: 'Dashboards.Inspections.Inspection',
    Inspections_RBI: 'Dashboards.Inspections.RBI',
    Inspections_Thickness: 'Dashboards.Inspections.Thickness',
    Inspections_AIInspect: 'Dashboards.Inspections.AI Inspect',
    Inspections_CathodicProtection: 'Dashboards.Inspections.Cathodic Protection',
    Inspections_IOWs: 'Dashboards.Inspections.IOWs',
    Inspections_CorrosionAnalyser: 'Dashboards.Inspections.Corrosion Analyser',
    Inspections_CoatingAnalyser: 'Dashboards.Inspections.Coating Analyser',
  },
  CustomDashboards: {
    View: 'CustomDashboards.View',
    Manage: 'CustomDashboards.Manage',
  },
  Admin: {
    Access: 'Admin.Access',
  },
  GeneralSettings: {
    View: 'General Settings.View',
    Update: 'General Settings.Update',
  },
  Admin3DModels: {
    Upload: 'Admin 3D Models.Upload',
    View: 'Admin 3D Models.View',
    Delete: 'Admin 3D Models.Delete',
  },
  Models3D: {
    View: '3D Models.View',
  },
  AdminPointClouds: {
    Upload: 'Admin Point Clouds.Upload',
    Delete: 'Admin Point Clouds.Delete',
    Converter: 'Admin Point Clouds.Converter',
  },
  GPSSettings: {
    Access: 'Admin GPS Settings.Access',
  },
  PlotPlans2D: {
    Access: '2D Plot Plans.View',
  },
  Areas: {
    View: 'Areas.View',
    Create: 'Areas.Create',
    Update: 'Areas.Update',
    Delete: 'Areas.Delete',
  },
  AdminFacilityLevels: {
    Create: 'Admin Facility Levels.Create',
    View: 'Admin Facility Levels.View',
    Update: 'Admin Facility Levels.Update',
    Delete: 'Admin Facility Levels.Delete',
  },
  Images360: {
    View: '360 Images.View',
  },
  Admin360Images: {
    Projects: 'Admin 360 Images.Projects',
    Upload: 'Admin 360 Images.Upload',
    View: 'Admin 360 Images.View',
    Update: 'Admin 360 Images.Update',
    Delete: 'Admin 360 Images.Delete',
  },
  Categories: {
    Create: 'Admin Tag Categories.Create',
    View: 'Admin Tag Categories.View',
    Update: 'Admin Tag Categories.Update',
    Delete: 'Admin Tag Categories.Delete',
  },
  AdminMarkupsStamps: {
    Create: 'Admin Markups Stamps.Create',
    View: 'Admin Markups Stamps.View',
    Update: 'Admin Markups Stamps.Update',
    Delete: 'Admin  Markups Stamps.Delete',
  },

  AdminMarkupSymbols: {
    Upload: 'Admin Markup Symbols.Upload',
    View: 'Admin Markup Symbols.View',
    Delete: 'Admin Markup Symbols.Delete',
  },
  TagHarvester: {
    Create: 'Tag Harvester.Create',
    View: 'Tag Harvester.View',
    Update: 'Tag Harvester.Update',
    Delete: 'Tag Harvester.Delete',
  },
  InspectionTags: {
    ImportExport: 'Inspection Tags.Import/Export',
    Create: 'Inspection Tags.Create',
    View: 'Inspection Tags.View',
    Update: 'Inspection Tags.Update',
    Delete: 'Inspection Tags.Delete',
  },

  Bookmarks: {
    Create: 'Bookmarks.Create',
    View: 'Bookmarks.View',
    Delete: 'Bookmarks.Delete',
  },
  ProjectModels: {
    Upload: 'Project Models.Upload',
    View: 'Project Models.View',
    Delete: 'Project Models.Delete',
  },
  Tags: {
    Anomaly: {
      Create: 'Tags.Anomaly.Create',
      View: 'Tags.Anomaly.View',
      Update: 'Tags.Anomaly.Update',
      Delete: 'Tags.Anomaly.Delete',
    },
    AvaInspect: {
      Create: 'Tags.AvaInspect.Create',
      View: 'Tags.AvaInspect.View',
      Update: 'Tags.AvaInspect.Update',
      Delete: 'Tags.AvaInspect.Delete',
    },
    Container: {
      Create: 'Tags.Container.Create',
      View: 'Tags.Container.View',
      Update: 'Tags.Container.Update',
      Delete: 'Tags.Container.Delete',
    },
    Equipment: {
      Create: 'Tags.Equipment.Create',
      View: 'Tags.Equipment.View',
      Update: 'Tags.Equipment.Update',
      Delete: 'Tags.Equipment.Delete',
    },
    General: {
      Create: 'Tags.General.Create',
      View: 'Tags.General.View',
      Update: 'Tags.General.Update',
      Delete: 'Tags.General.Delete',
    },
    Groups: {
      Create: 'Tags.Groups.Create',
      View: 'Tags.Groups.View',
      Delete: 'Tags.Groups.Delete',
    },
    Permit: {
      Create: 'Tags.Permit.Create',
      View: 'Tags.Permit.View',
      Update: 'Tags.Permit.Update',
      Delete: 'Tags.Permit.Delete',
    },
    Pipeline: {
      Create: 'Tags.Pipeline.Create',
      View: 'Tags.Pipeline.View',
      Update: 'Tags.Pipeline.Update',
      Delete: 'Tags.Pipeline.Delete',
    },
    Scaffold: {
      Create: 'Tags.Scaffold.Create',
      View: 'Tags.Scaffold.View',
      Update: 'Tags.Scaffold.Update',
      Delete: 'Tags.Scaffold.Delete',
    },
    Structural: {
      Create: 'Tags.Structural.Create',
      View: 'Tags.Structural.View',
      Update: 'Tags.Structural.Update',
      Delete: 'Tags.Structural.Delete',
    },
    Masters: {
      Create: 'Tags.Masters.Create',
      View: 'Tags.Masters.View',
      Update: 'Tags.Masters.Update',
      Delete: 'Tags.Masters.Delete',
    },
  },

  Documents: {
    Upload: 'Documents.Upload',
    View: 'Documents.View',
    Update: 'Documents.Update',
    Delete: 'Documents.Delete',
  },
  Markups: {
    Create: 'Markups.Create',
    View: 'Markups.View',
    Update: 'Markups.Update',
    Delete: 'Markups.Delete',
  },

  ModelBrowser: {
    View: 'Model Browser.View',
  },
  CustomPointcloudDownload: {
    Create: 'Custom Pointcloud Download.Create',
    View: 'Custom Pointcloud Download.View',
    Delete: 'Custom Pointcloud Download.Delete',
    ReCapDownload: 'Custom Pointcloud Download.ReCap Download',
  },
  CompanyProfile: {
    View: 'Company Profile.View',
    Update: 'Company Profile.Update',
    SsoSettings: 'Company Profile.SSO Settings',
    ApiKeys: 'Company Profile.Api Keys',
  },
  CompaniesManagement: {
    Create: 'Company.Create',
    View: 'Company.View',
    Update: 'Company.Update',
    Delete: 'Company.Delete',
    Impersonate: 'Company.Impersonate',
    StorageSettings: 'Company.Storage Settings',
    UICustomization: 'Company.UI Customization',
  },
  ReleaseNotes: {
    View: 'Release Notes.View',
    Edit: 'Release Notes.Edit',
    Publish: 'Release Notes.Publish',
    Settings: 'Release Notes.Settings',
  },
  Facilities: {
    Create: 'Facilities.Create',
    View: 'Facilities.View',
    Update: 'Facilities.Update',
    Delete: 'Facilities.Delete',
  },
  Clients: {
    Create: 'Clients.Create',
    View: 'Clients.View',
    Delete: 'Clients.Delete',
  },
  Contractors: {
    Create: 'Contractors.Create',
    View: 'Contractors.View',
    Update: 'Contractors.Update',
    Delete: 'Contractors.Delete',
  },
  Contracts: {
    Create: 'Contracts.Create',
    View: 'Contracts.View',
    Update: 'Contracts.Update',
    Delete: 'Contracts.Delete',
  },
  TaskBoardProjects: {
    Create: 'Task Board Projects.Create',
    View: 'Task Board Projects.View',
    Update: 'Task Board Projects.Update',
    Delete: 'Task Board Projects.Delete',
  },
  AdminTaskManager: {
    View: 'AdminTaskManager.View',
  },

  AdminTaskStatuses: {
    Create: 'Admin Task Statuses.Create',
    View: 'Admin Task Statuses.View',
    Update: 'Admin Task Statuses.Update',
    Delete: 'Admin Task Statuses.Delete',
  },
  AdminTaskFields: {
    Create: 'Admin Task Fields.Create',
    View: 'Admin Task Fields.View',
    Update: 'Admin Task Fields.Update',
    Delete: 'Admin Task Fields.Delete',
    Grouping: 'Admin Task Fields.Grouping',
  },

  Tasks: {
    Create: 'Tasks.Create',
    // View: 'Tasks.View',
    Update: 'Tasks.Update',
    Delete: 'Tasks.Delete',
  },
  TaskTracker: {
    View: 'Task Tracker.View',
  },
  Gantt: {
    View: 'Gantt.View',
  },
  Scheduler: {
    View: 'Scheduler.View',
  },
  AI: {
    Access: 'AI.Access',
  },

  // Register management permissions
  Registers: {
    Create: 'Registers.Create',
    View: 'Registers.View',
    Update: 'Registers.Update',
    Delete: 'Registers.Delete',
    Import: 'Registers.Import',
    Export: 'Registers.Export',
  },

  // Composite data source permissions
  DataSources: {
    Create: 'DataSources.Create',
    View: 'DataSources.View',
    Update: 'DataSources.Update',
    Delete: 'DataSources.Delete',
  },

  // Task Import management permissions
  TaskImport: {
    View: 'TaskImport.View',
    Execute: 'TaskImport.Execute',
  },
};

export default permissions;
